<script lang="ts">
    import { browser } from '$app/environment';
    import { page } from '$app/state';
    import { pushEvent } from '$src/lib/services/gtm';
    import { onMount } from 'svelte';
    import { GTM_EVENT_NAMES } from '../../constants';

    onMount(() => {
        if (page.data.isFirstTimeVisit && browser) {
            pushEvent(GTM_EVENT_NAMES.FIRST_TIME_VISIT);
        }
    });
</script>
